import { useEffect, useState } from 'react';

/**
 * Phase 16.R7: delay propagating a value (e.g. caption → ML panels) without lagging the input.
 */
export default function useDebouncedValue(value, delayMs = 400) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), Math.max(0, delayMs));
    return () => clearTimeout(t);
  }, [value, delayMs]);

  return debounced;
}
